module.exports = {
  version: 'v1.8.6',
  verCfg: {
    dev: {
      xos: 1156,
      xl_gx: 1054,
      xl_thunder: 1221,
      xl_dcdn: 1024,
      xl_thumb: 1051,
      xl_scrape: 1110,
      xl_disk: 1219,
      xl_shell: 1298,
      xl_backer: 1121,
    },
    stable: {
      xos: 1156,
      xl_gx: 1054,
      xl_thunder: 1221,
      xl_dcdn: 1024,
      xl_thumb: 1051,
      xl_scrape: 1110,
      xl_disk: 1219,
      xl_shell: 1298,
      xl_backer: 1121,
    },
    beta: {
      xos: 1156,
      xl_gx: 1054,
      xl_thunder: 1221,
      xl_dcdn: 1024,
      xl_thumb: 1051,
      xl_scrape: 1110,
      xl_disk: 1219,
      xl_shell: 1298,
      xl_backer: 1121,
    },
  },
}
